<div class="menu-acheter">
  <div class="menu-main">
    <div class="menu-main-item">
      <a [routerLink]="['/biens-a-vendre/page/1']">
        <div class="menu-main-item-icon">
          <img width="40" height="40" src="assets/svg/rechercher-bien.svg" alt="">
        </div>
      </a>
      <a [routerLink]="['/biens-a-vendre/page/1']" class="lien-txt">
        <div class="menu-main-item-text">
          <span class="bold-base">Rechercher un bien à vendre</span>
          <span class="normal-sm">Trouvez votre futur appartement ou maison</span>
        </div>
      </a>
    </div>
    <div class="menu-main-item">
      <a [routerLink]="['/accueil']" fragment="ancre-ebooks" class="lien-txt">
        <div class="menu-main-item-icon">
          <img width="38" height="40" src="assets/svg/reussir-achat.svg" alt="">
        </div>
      </a>
      <a [routerLink]="['/accueil']" fragment="ancre-ebooks" class="lien-txt">
        <div class="menu-main-item-text">
          <span class="bold-base">Réussir votre achat immobilier</span>
          <span class="normal-sm">Tous nos conseils et nos services pour bien acheter</span>
        </div>
      </a>
    </div>
    <!--    <div class="menu-main-item">-->
    <!--      <a [routerLink]="['/accueil']" fragment="ancre-success-stories">-->
    <!--        <div class="menu-main-item-icon">-->
    <!--          <img src="assets/svg/success-stories.svg" alt="Témoignages Opinion System">-->
    <!--        </div>-->
    <!--      </a>-->
    <!--      <a [routerLink]="['/accueil']" fragment="ancre-success-stories" class="lien-txt">-->
    <!--        <div class="menu-main-item-text">-->
    <!--          <span class="bold-base">Success stories</span>-->
    <!--          <span class="normal-sm">Découvrez les témoignages de vendeurs comme vous</span>-->
    <!--        </div>-->
    <!--      </a>-->
    <!--    </div>-->
  </div>
  <div class="menu-secondary">
    <div class="bold-xl"><span class="seconday01dark">Prêt immobilier</span> : estimez vos capacités d’emprunt</div>
    <div class="semibold-sm gray700">Notre partenaire IN&FI Crédits vous fait profiter des meilleurs taux du marché.
    </div>
    <button (click)="onNavigateCapacite()" type="button" class="btn btn-gold external-link">Calculer votre prêt
      immobilier</button>
  </div>
</div>
